import React from "react"
import propTypes from "prop-types"
import { CSSTransition } from "react-transition-group"

import GlobalForm, { Group } from "../../../../../../components/Form"
import Button from "../../../../../../components/Button"

class Form extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isHidden: true
    }
  }

  componentDidUpdate(prevProps) {
    const { hideAllForm } = this.props

    if (prevProps.hideAllForm !== hideAllForm) {
      this.hideAllForm()
    }
  }

  scrollTo = el => {
    const offSet = el.getBoundingClientRect().top + window.pageYOffset

    const supportsNativeSmoothScroll =
      "scrollBehavior" in document.documentElement.style

    if (supportsNativeSmoothScroll) {
      window.scrollTo({
        top: offSet,
        behavior: "smooth"
      })
    } else {
      window.scrollTo(0, offSet)
    }
  }

  hideAllForm = () => {
    this.setState({ isHidden: true })
  }

  handleSaveForm = () => {
    const { onFormSave } = this.props

    onFormSave()
  }

  handleOpenForm = () => {
    const { onFormOpen } = this.props

    onFormOpen(() => {
      this.setState({
        isHidden: false
      })

      setTimeout(() => {
        this.scrollTo(this.form)
      }, 500)
    })
  }

  handleCloseForm = () => {
    const card = this.form.closest(".info-card")

    this.setState(
      {
        isHidden: true
      },
      () => {
        setTimeout(() => {
          this.scrollTo(card)
        }, 500)
      }
    )
  }

  render() {
    const { children, archiveNotification, openButtonText } = this.props
    const { isHidden } = this.state

    return (
      <div className="info-card_form">
        <CSSTransition
          in={isHidden}
          unmountOnExit
          timeout={600}
          classNames="info-card_form_btns"
        >
          <div className="info-card_form_btns">
            <Button
              button={{ type: "button" }}
              onClick={this.handleOpenForm}
              className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-sm"
            >
              {openButtonText}
            </Button>
            <Button
              button={{ type: "button" }}
              onClick={archiveNotification}
              className="btn--cancel btn--archive btn--width-md btn--height-sm btn--font-size-sm"
            >
              Archive
            </Button>
          </div>
        </CSSTransition>

        <CSSTransition
          in={!isHidden}
          unmountOnExit
          timeout={300}
          classNames="form"
        >
          <GlobalForm
            formRef={el => {
              this.form = el
            }}
          >
            {children}

            <Group className="form_btn-group">
              <Button
                button={{ type: "button" }}
                className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-sm"
                onClick={this.handleSaveForm}
              >
                Save Changes
              </Button>
              <Button
                button={{ type: "button" }}
                className="btn--cancel btn--width-md btn--height-sm btn--font-size-sm"
                onClick={this.handleCloseForm}
              >
                Cancel
              </Button>
            </Group>
          </GlobalForm>
        </CSSTransition>
      </div>
    )
  }
}

Form.propTypes = {
  openButtonText: propTypes.string.isRequired,
  onFormOpen: propTypes.func.isRequired,
  onFormSave: propTypes.func.isRequired,
  hideAllForm: propTypes.bool.isRequired,
  archiveNotification: propTypes.func.isRequired,
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired
}

export default Form
